export const DAY_PERIOD_KEY = 'DAY_PERIOD_KEY';
export const MONTH_PERIOD_KEY = 'MONTH_PERIOD_KEY';
export const HOUR_PERIOD_KEY = 'HOUR_PERIOD_KEY';
export const MINUTE_PERIOD_KEY = 'MINUTE_PERIOD_KEY';

export const MINUTE_GROUPING = 4;
